// src/hooks/useCanvasEvents.js
import { useEffect } from "react";

export default function useCanvasEvents({
  canvas,
  onUpdateDimensions,
  onUpdatePricing,
}) {
  useEffect(() => {
    if (!canvas) return;

    // ONLY PRICING + DIMENSIONS — NO ZOOM
    const handleModified = (e) => {
      const obj = e.target;
      if (obj?.type !== "i-text") return;

      const text = obj.text || "";
      if (obj._lastText !== text) {
        obj._lastText = text;
        onUpdateDimensions?.({
          text,
          font: obj.fontFamily,
          size: obj.height / 96,
        });
      }
      onUpdatePricing?.((obj.getScaledWidth() / 96) * 5);
    };

    canvas.on("text:changed", handleModified);
    canvas.on("object:modified", handleModified);

    return () => {
      canvas.off("text:changed", handleModified);
      canvas.off("object:modified", handleModified);
    };
  }, [canvas, onUpdateDimensions, onUpdatePricing]);
}
